import { types } from "../action-types";

const initialState = {
  loading: false,
  success: false,
  error: false,
};

const updateProposalReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_PROPOSAL_REQUESTED:
      return {
        ...state,
        loading: action.payload.loading,
        success: false,
      };

    case types.UPDATE_PROPOSAL_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload,
        error: false,
      };

    case types.UPDATE_PROPOSAL_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
      };

    default:
      return state;
  }
};
export default updateProposalReducers;
